export var FormType;
(function (FormType) {
    FormType[FormType["StartChat"] = 1] = "StartChat";
    FormType[FormType["ChatSurvey"] = 2] = "ChatSurvey";
    FormType[FormType["WrapUp"] = 3] = "WrapUp";
    FormType[FormType["Deflection"] = 4] = "Deflection";
    FormType[FormType["IVR"] = 5] = "IVR";
    FormType[FormType["OfflineDeflection"] = 6] = "OfflineDeflection";
})(FormType || (FormType = {}));
export default FormType;
//# sourceMappingURL=form-type.js.map